import { memo, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex } from '@/lib/v2/components';

interface ButtonsSection {
  textAction?: string;
  textClose?: string;
  onAction?: MouseEventHandler<HTMLButtonElement>;
  onClose?: MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
}

const ButtonsSection = ({
  onAction,
  onClose,
  textAction,
  textClose,
  isLoading,
}: ButtonsSection) => {
  const { t } = useTranslation();

  const cancel = textClose ?? t('CREATE_SEGMENT_MODAL.cancel');
  const action = textAction ?? t('CREATE_SEGMENT_MODAL.confirm');

  return (
    <div className="pt-4">
      <Flex withGap alignment="end" gapSize="small">
        <Button outline disabled={isLoading} onClick={onClose}>
          {cancel}
        </Button>
        <Button isLoading={isLoading} typeButton="submit" onClick={onAction}>
          {action}
        </Button>
      </Flex>
    </div>
  );
};

export default memo(ButtonsSection);
